export default "__VITE_ASSET__be1f4257__"